<template>
  <div style="padding: 32px; background: #f0f2f5; min-height: 100vh">
    <el-card shadow="none" style="margin-bottom: 24px">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center">
          <el-input
            v-model="search"
            placeholder="请输入备注"
            clearable
            style="width: 200px; margin-right: 12px"
            size="medium"
            @keyup.enter="onSearch"
          />
          <el-button type="primary" size="medium" style="margin-right: 8px" @click="onSearch">搜索</el-button>
          <el-button size="medium" @click="onReset">重置</el-button>
        </div>
        <el-button type="success" icon="el-icon-plus" size="medium" @click="onCreate">创建</el-button>
      </div>
    </el-card>

    <el-card shadow="none">
      <el-table
        :data="loading ? skeletonRows : tableData"
        border
        style="width: 100%"
        :header-cell-style="headerStyle"
        :cell-style="cellStyle"
        :row-class-name="rowClassName"
      >
        <el-table-column prop="html_no" label="编号" align="center" min-width="100">
          <template slot-scope="scope">
            <span v-if="!loading" class="copyable" @click="copyToClipboard(scope.row.html_no, '编号')">
              {{ scope.row.html_no }}
            </span>
            <div v-else class="skeleton-cell" />
          </template>
        </el-table-column>

        <el-table-column prop="distinguish_text" label="是否区分A/B页" align="center">
          <template slot-scope="scope">
            <span v-if="!loading">{{ scope.row.distinguish_text }}</span>
            <div v-else class="skeleton-cell" />
          </template>
        </el-table-column>

        <el-table-column prop="urls" label="浏览链接" align="center" min-width="250">
          <template slot-scope="scope">
            <div v-if="!loading">
              <template v-if="Array.isArray(scope.row.urls)">
                <div v-for="(url, idx) in scope.row.urls" :key="idx" style="display: flex; align-items: flex-start; gap: 6px">
                  <span style="color: #777;">{{ idx + 1 }}.</span>
                  <el-link :underline="false" style="color: #165dffbf; cursor: pointer" @click.native.prevent="copyToClipboard(url, '链接')">{{ url }}</el-link>
                </div>
              </template>
              <template v-else>
                <el-link :underline="false" style="color: #165dffbf; cursor: pointer" @click.native.prevent="copyToClipboard(scope.row.urls, '链接')">{{ scope.row.urls }}</el-link>
              </template>
            </div>
            <div v-else class="skeleton-cell" style="height: 22px" />
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" align="center">
          <template slot-scope="scope">
            <span v-if="!loading">{{ scope.row.remark }}</span>
            <div v-else class="skeleton-cell" />
          </template>
        </el-table-column>

        <el-table-column prop="created_at_text" label="创建时间" align="center">
          <template slot-scope="scope">
            <span v-if="!loading">{{ scope.row.created_at_text }}</span>
            <div v-else class="skeleton-cell" />
          </template>
        </el-table-column>

        <el-table-column label="编辑" align="center">
          <template slot-scope="scope">
            <template v-if="!loading">
              <el-button
                type="text"
                size="medium"
                style="color: rgb(22, 93, 255)"
                :loading="editLoadingMap[scope.row.html_no]"
                :disabled="editLoadingMap[scope.row.html_no]"
                @click="onEdit(scope.row)"
              >修改</el-button>
              <el-divider direction="vertical" />
              <el-button
                type="text"
                size="medium"
                style="color: #f56c6c"
                @click="onDelete(scope.row)"
              >删除</el-button>
            </template>
            <div v-else class="skeleton-cell" />
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onCurrentChange"
        />
      </div>
    </el-card>

    <CreateDialog
      v-model="dialogVisible"
      :edit-data="currentEditData"
      @preview="handlePreview"
      @success="fetchList"
    />

    <el-dialog
      title="HTML页面实时预览"
      :visible.sync="previewVisible"
      width="440px"
      :z-index="3000"
      :close-on-click-modal="true"
      @close="previewHtml = ''"
    >
      <iframe
        v-if="previewHtml"
        :srcdoc="previewHtml"
        style="width: 100%; height: 660px; border: none; border-radius: 12px; background: #f2f2f2;"
      />
    </el-dialog>
  </div>
</template>

<script>
import CreateDialog from './components/CreateDialog.vue'
import { adHtmlList, delAdHtml, adHtmldetail } from '@/api/createDialog'

export default {
  components: { CreateDialog },
  data() {
    return {
      dialogVisible: false,
      search: '',
      previewHtml: '',
      previewVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      editLoadingMap: {},
      currentEditData: null,
      skeletonRows: Array(8).fill({})
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    headerStyle() {
      return {
        background: '#F5F7FA',
        color: '#333',
        fontWeight: 600,
        textAlign: 'center'
      }
    },
    cellStyle() {
      return { textAlign: 'center' }
    },
    rowClassName({ rowIndex }) {
      return rowIndex % 2 === 1 ? 'el-table__row--striped' : ''
    },
    handlePreview(html) {
      this.previewHtml = html
      this.dialogVisible = false
      setTimeout(() => {
        this.previewVisible = true
      }, 300)
    },
    onCreate() {
      this.currentEditData = null
      this.dialogVisible = true
    },
    async onEdit(row) {
      const key = row.html_no
      if (this.editLoadingMap[key]) return
      this.$set(this.editLoadingMap, key, true)
      try {
        const res = await adHtmldetail({ html_no: key })
        const detail = res.data.detail
        if (!detail) throw new Error('接口无数据')
        let realForm = {}; let realColorConfig = {}; let fakeForm = {}; let fakeColorConfig = {}
        try {
          if (detail.html_text) {
            const a = JSON.parse(detail.html_text)
            realForm = a.form || a
            realColorConfig = a.colorConfig || {}
          }
          if (detail.ad_html_text) {
            const b = JSON.parse(detail.ad_html_text)
            fakeForm = b.form || b
            fakeColorConfig = b.colorConfig || {}
          }
        } catch (e) {
          console.warn('JSON解析出错', e)
        }
        this.currentEditData = {
          html_no: key,
          distinguish: detail.distinguish,
          remark: detail.remark || '',
          realForm,
          realColorConfig,
          fakeForm,
          fakeColorConfig
        }
        this.dialogVisible = true
      } catch (e) {
        this.$message.error('获取页面详情失败')
        console.error('页面详情报错', e)
      } finally {
        this.$set(this.editLoadingMap, key, false)
      }
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await adHtmlList({
          page: this.page,
          pageSize: this.pageSize,
          keywords: this.search
        })
        this.tableData = res.data?.list || []
        this.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      this.page = 1
      this.fetchList()
    },
    onReset() {
      this.search = ''
      this.page = 1
      this.fetchList()
    },
    onCurrentChange(val) {
      this.page = val
      this.fetchList()
    },
    onDelete(row) {
      this.$confirm('确认删除该页面吗？', '提示', { type: 'warning' })
        .then(async() => {
          try {
            await delAdHtml({ html_no: row.html_no })
            this.$message.success('删除成功！')
            this.fetchList()
          } catch (e) {
            this.$message.error('删除失败！')
          }
        })
        .catch(() => {})
    },
    copyToClipboard(val, type = '内容') {
      if (!val) return
      if (navigator.clipboard) {
        navigator.clipboard.writeText(val).then(() => {
          this.$message.success(`已复制${type}！`)
        })
      } else {
        const input = document.createElement('input')
        input.value = val
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success(`已复制${type}！`)
      }
    }
  }
}
</script>

<style>
.el-table th,
.el-table td {
  border-right: none !important;
}
.el-table {
  border-left: 1px solid #ebeef5 !important;
  border-right: 1px solid #ebeef5 !important;
  border-bottom: 1px solid #ebeef5 !important;
  border-top: 1px solid #ebeef5 !important;
}
.copyable {
  cursor: pointer;
  color: #165dffbf;
}
.copyable:hover {
  text-decoration: underline;
}
.skeleton-cell {
  flex: 1;
  height: 32px;
  margin-right: 12px;
  background: linear-gradient(90deg, #f4f4f5 25%, #e9ecef 37%, #f4f4f5 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: skeleton-loading 1.2s ease-in-out infinite;
}
.skeleton-cell:last-child {
  margin-right: 0;
}
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
